module.exports = __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/assessment_incomplete_1-06b0483a7a90581e5b4a8ca6e0deeebc.svg";